import * as React from 'react'
import Dialog from '@mui/material/Dialog'
import Slide from '@mui/material/Slide'
import {TransitionProps} from '@mui/material/transitions'
import {styled} from '@mui/material'

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction='up' ref={ref} {...props} />
})

const Title = styled('h4')(() => ({
  margin: 0,
  marginBottom: '8px',
  textTransform: 'capitalize',
}))

const DialogBox = styled('div')(() => ({
  width: 400,
  padding: '32px',
  textAlign: 'center',
  marginLeft: 'auto',
  marginRight: 'auto',
}))

const Controller = styled('div')(() => ({
  margin: '16px 0 8px 0',
  paddingTop: '8px',
  display: 'flex',
  justifyContent: 'center',
  gap: '12px',
}))

const Message = styled('p')(() => ({
  margin: '16px 0',
  color: '#5e6278',
  fontSize: '14px',
  lineHeight: '1.5',
}))

interface RegistrationSuccessModal {
  open: boolean
  onProceedToLogin: () => void
  onClose?: () => void
}

const RegistrationSuccessDialog = ({open, onProceedToLogin, onClose}: RegistrationSuccessModal) => {
  return (
    <div>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={onClose}
      >
        <DialogBox>
          <i className='text-success fs-2tx bi bi-check2-circle'></i>
          <Title className='mt-5 text-success'>Account Created Successfully!</Title>
          <Message>
            Your account has been created successfully. Please verify your email to continue.
          </Message>
          <Controller>
            <button 
              className='btn btn-primary btn-sm px-4' 
              onClick={onProceedToLogin}
            >
              Proceed to Login
            </button>
          </Controller>
        </DialogBox>
      </Dialog>
    </div>
  )
}

export default RegistrationSuccessDialog
